import { Grid } from "@mui/material";
import { isFulfilled } from "@reduxjs/toolkit";
import { useEffect, useState } from "react";
import { useAppDispatch } from "../../../app/hooks";
import useCurrentUser from "../../../hooks/useCurrentUser";
import { OrderBundleComment, OrderBundleCommentAdded } from "../orderAPI";
import { fetchOrderBundleComments } from "../orderBundleCommentsSlice";
import AddOrderBundleCommentComponent from "./AddOrderBundleComment";
import OrderBundleCommentHistory from "./OrderBundleCommentHistory";

type Props = {
  bundleId: string;
};

const OrderBundleComments = ({ bundleId }: Props) => {
  const dispatch = useAppDispatch();
  const { user } = useCurrentUser();
  const [comments, setComments] = useState<OrderBundleComment[]>([]);

  useEffect(() => {
    dispatch(fetchOrderBundleComments({ bundleId })).then((action) => {
      if (isFulfilled(action)) {
        setComments(action.payload);
      }
    });
  }, [bundleId, dispatch]);

  const handleCommentAdded = (
    id: string,
    version: number,
    payload: OrderBundleCommentAdded,
  ) => {
    const newComment: OrderBundleComment = {
      id,
      version,
      bundleId,
      comment: payload.comment,
      dateTime: Date.now(),
      authorId: user!.id,
      authorName: `${user!.firstName} ${user!.lastName}`,
    };
    setComments((prev) => [newComment, ...prev]);
  };

  return (
    <Grid container sx={{ paddingRight: "7px" }}>
      <Grid container sx={{ paddingLeft: "7px" }}>
        {user && (
          <AddOrderBundleCommentComponent
            bundleId={bundleId}
            firstName={user.firstName}
            lastName={user.lastName}
            onCommentAdded={handleCommentAdded}
          />
        )}
      </Grid>
      <Grid container>
        <OrderBundleCommentHistory
          comments={comments}
          currentUserId={user?.id ?? null}
          onCommentsUpdated={setComments}
        />
      </Grid>
    </Grid>
  );
};

export default OrderBundleComments;
